import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { MissionLifecycleFragmentFragment, MissionContractPaymentState } from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import MoneyDisplay from "@/components/feature/MoneyDisplay.vue"
import { computed } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientBilling',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission: MissionLifecycleFragmentFragment
}



const { formatDate } = useUtilities()

const getIcon = (state: MissionContractPaymentState) => {
  const map: Record<MissionContractPaymentState, string> = {
    [MissionContractPaymentState.Paid]: "check-circle",
    [MissionContractPaymentState.Processing]: "history-3",
    [MissionContractPaymentState.Pending]: "clock-circle",
  }

  return map[state] || "record"
}

const bills = computed(() => {
  return props.mission.missionContract?.missionContractPayments.filter(
    (payment) => payment.state !== MissionContractPaymentState.Pending
  )
})

return { __sfc: true,props, formatDate, getIcon, bills, Icon, MoneyDisplay }
}

})